import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

interface ApiConfig<TQueryFnData, TData, TError> {
  queryOptions: Omit<
    UseQueryOptions<TQueryFnData, AxiosError<TError>, TData>,
    "queryKey" | "queryFn"
  > & {
    queryKey: UseQueryOptions<
      TQueryFnData,
      AxiosError<TError>,
      TData
    >["queryKey"];
    queryFn: UseQueryOptions<
      TQueryFnData,
      AxiosError<TError>,
      TData
    >["queryFn"];
  };
}

// Should prolly fix this at some point. FastAPI services return detail as JSON,
// Flask is string. But everything in this project uses ApiError and is coded
// assuming it's always a string.
export type ApiError = AxiosError<{
  detail: string;
}>;

export function useApi<TQueryFnData, TData = TQueryFnData, TError = ApiError>({
  queryOptions,
}: ApiConfig<TQueryFnData, TData, TError>) {
  return useQuery<TQueryFnData, AxiosError<TError>, TData>({
    ...queryOptions,
  });
}
